import { render, staticRenderFns } from "./GuestLayout.vue?vue&type=template&id=6679bb0c&scoped=true"
import script from "./GuestLayout.vue?vue&type=script&lang=js"
export * from "./GuestLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679bb0c",
  null
  
)

export default component.exports